export const file = {
  title: 'File',
  restrictions: 'Restrictions',
  maxFileSize: 'Maximum file size',
  maxFiles: 'Maximum number of files',
  allowedTypes: 'Allowed file extensions',
  noFile: 'No file',
  fileAdded: 'File uploaded successfully',
  invalidFileType: 'Invalid file type.',
}
